var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPs = function SvgIconPs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.304 7.827h15.95C21.557 3.257 17.158 0 11.998 0a11.96 11.96 0 0 0-8.484 3.515z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M7.304 16.174h15.95C21.557 20.744 17.158 24 11.998 24a11.96 11.96 0 0 1-8.484-3.515z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M3.515 3.515c-4.687 4.686-4.687 12.284 0 16.97L12 12z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconPs;